import { render, staticRenderFns } from "./WsRequestExamsForm.vue?vue&type=template&id=2156dfda&scoped=true"
import script from "./WsRequestExamsForm.vue?vue&type=script&lang=js"
export * from "./WsRequestExamsForm.vue?vue&type=script&lang=js"
import style0 from "./WsRequestExamsForm.vue?vue&type=style&index=0&id=2156dfda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2156dfda",
  null
  
)

export default component.exports